module.exports = __webpack_public_path__ + "media/images/portugal_center/Tejo-adce5d6cac18b2dcf5fb9265e4402e55.jpg";